import React from 'react';
import WeducWebAttribution from '@accrosoft-ltd/accropress-websites-components/dist/esm/WeducWebAttribution';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var gatsbyConfig = require('../../theme-config.js');

var gatsbyConfigSiteMetaData = gatsbyConfig.siteMetadata;
var gatsbyConfigPlugins = gatsbyConfig.plugins;
var gatsbyConfigPluginsAP = gatsbyConfigPlugins.find(function (o) {
  return o.resolve === 'gatsby-plugin-accropress';
});
var gatsbyConfigPluginsAPOptions = gatsbyConfigPluginsAP.options;

var Footer = function Footer(props) {
  var footerWidgetData = [];

  if (gatsbyConfigPluginsAPOptions) {
    footerWidgetData = gatsbyConfigPluginsAPOptions.siteSettings.widgetsPayload && gatsbyConfigPluginsAPOptions.siteSettings.widgetsPayload.length > 0 ? gatsbyConfigPluginsAPOptions.siteSettings.widgetsPayload.find(function (o) {
      return o.widgetID === 'footer';
    }) : gatsbyConfigPluginsAPOptions.siteSettings.theme && gatsbyConfigPluginsAPOptions.siteSettings.theme.widgetsDefinition && gatsbyConfigPluginsAPOptions.siteSettings.theme.widgetsDefinition.find(function (o) {
      return o.widgetID === 'footer';
    });
  }

  return /*#__PURE__*/_jsx("footer", {
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsx("div", {
        className: "row",
        children: footerWidgetData && footerWidgetData.children.map(function (widget, i) {
          return /*#__PURE__*/_jsx(_Fragment, {
            children: widget.id === 'footer-contact-details' ? /*#__PURE__*/_jsxs("div", {
              className: "col-12 col-3-m",
              children: [/*#__PURE__*/_jsx("div", {
                className: "header",
                children: widget.name
              }), /*#__PURE__*/_jsxs("div", {
                className: "address",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "addressName",
                  children: widget.children && widget.children[0] ? widget.children[0][0].value || widget.children[0][0].default : widget.columns[0].value || widget.columns[0].default
                }), /*#__PURE__*/_jsx("p", {
                  children: widget.children && widget.children[0] ? widget.children[0][1].value || widget.children[0][1].default : widget.columns[0].value || widget.columns[1].default
                }), /*#__PURE__*/_jsx("p", {
                  children: widget.children && widget.children[0] ? widget.children[0][2].value || widget.children[0][2].default : widget.columns[0].value || widget.columns[2].default
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "contact",
                children: [/*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "fas fa-mobile-alt"
                  }), " Tel:", ' ', /*#__PURE__*/_jsx("a", {
                    href: "tel:" + (widget.children && widget.children[0] ? widget.children[0][3].value || widget.children[0][3].default : widget.columns[0].value || widget.columns[3].default),
                    children: widget.children && widget.children[0] ? widget.children[0][3].value || widget.children[0][3].default : widget.columns[0].value || widget.columns[3].default
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "far fa-envelope"
                  }), ' ', /*#__PURE__*/_jsx("a", {
                    href: "mailto:" + (widget.children && widget.children[0] ? widget.children[0][4].value || widget.children[0][4].default : widget.columns[0].value || widget.columns[4].default),
                    children: widget.children && widget.children[0] ? widget.children[0][4].value || widget.children[0][4].default : widget.columns[0].value || widget.columns[4].default
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: "social-links",
                  children: [widget.children[0][5] && widget.children[0][5].value && /*#__PURE__*/_jsx("a", {
                    href: widget.children[0][5].value,
                    target: "_blank",
                    class: "social",
                    children: /*#__PURE__*/_jsx("span", {
                      class: "fab fa-instagram"
                    })
                  }), widget.children[0][6] && widget.children[0][6].value && /*#__PURE__*/_jsx("a", {
                    href: widget.children[0][6].value,
                    target: "_blank",
                    class: "social",
                    children: /*#__PURE__*/_jsx("span", {
                      class: "fab fa-facebook-f"
                    })
                  }), widget.children[0][7] && widget.children[0][7].value && /*#__PURE__*/_jsx("a", {
                    href: widget.children[0][7].value,
                    target: "_blank",
                    class: "social",
                    children: /*#__PURE__*/_jsx("span", {
                      class: "fab fa-twitter"
                    })
                  })]
                })]
              })]
            }) : widget.id === 'footer-useful-links' || widget.id === 'footer-useful-resources' ? /*#__PURE__*/_jsxs("div", {
              className: "col-12 col-3-m",
              children: [/*#__PURE__*/_jsx("div", {
                className: "header",
                children: widget.name
              }), widget.children && widget.children[0] ? /*#__PURE__*/_jsx("ul", {
                children: widget.children.map(function (widgetChild) {
                  return /*#__PURE__*/_jsx(_Fragment, {
                    children: widgetChild.map(function (link, i) {
                      return /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsx("span", {
                          className: "fas fa-angle-right"
                        }), /*#__PURE__*/_jsx("a", {
                          target: link.newTab ? '_blank' : '_self',
                          href: link.value,
                          children: link.text
                        })]
                      });
                    })
                  });
                })
              }) : /*#__PURE__*/_jsx("ul", {
                children: widget.columns[0] && widget.columns[0].map(function (link, i) {
                  return /*#__PURE__*/_jsxs("li", {
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "fas fa-angle-right"
                    }), /*#__PURE__*/_jsx("a", {
                      target: link.newTab ? '_blank' : '_self',
                      href: link.value,
                      children: link.text
                    })]
                  });
                })
              })]
            }) : widget.id === 'footer-information' ? /*#__PURE__*/_jsxs("div", {
              className: "col-12 col-3-m",
              children: [/*#__PURE__*/_jsx("div", {
                className: "header",
                children: widget.name
              }), widget.children && widget.children[0] ? /*#__PURE__*/_jsx("ul", {
                children: widget.children.map(function (widgetChild) {
                  return /*#__PURE__*/_jsx(_Fragment, {
                    children: widgetChild.map(function (link, i) {
                      return /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsx("span", {
                          className: "fas fa-angle-right"
                        }), /*#__PURE__*/_jsx("a", {
                          target: link.newTab ? '_blank' : '_self',
                          href: link.value,
                          children: link.text
                        })]
                      });
                    })
                  });
                })
              }) : /*#__PURE__*/_jsx("ul", {
                children: widget.columns[0] && widget.columns[0].map(function (link, i) {
                  return /*#__PURE__*/_jsxs("li", {
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "fas fa-angle-right"
                    }), /*#__PURE__*/_jsx("a", {
                      target: link.newTab ? '_blank' : '_self',
                      href: link.value,
                      children: link.text
                    })]
                  });
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: "copyright",
                children: ["\xA9 ", gatsbyConfigSiteMetaData.title]
              }), /*#__PURE__*/_jsx("div", {
                className: "footer-icons",
                children: /*#__PURE__*/_jsx("div", {
                  className: "footer-icons-icon"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "websites-by-weduc",
                children: /*#__PURE__*/_jsx(WeducWebAttribution, {
                  campaignName: gatsbyConfigSiteMetaData.title
                })
              })]
            }) : /*#__PURE__*/_jsx("div", {
              className: "col-12 col-3-m"
            })
          });
        })
      })
    })
  });
};

export default Footer;